import { ButtonProps } from "../../types/item";
import Button from "../button";
import Flex from "../flex";
import Text from "../text";

const Dialog = ({
  description = "",
  buttons = [],
}: {
  description?: string;
  buttons?: ButtonProps[];
}) => {
  return (
    <div>
      <Text type="secondary" children={description} />
      {!!buttons.length && (
        <Flex gap={"1rem"} className="m-30-t">
          {buttons.map((button, index) => (
            <Button
              key={button.title || index}
              {...button}
              className={`min-w-0 flex-1 ${button.className || ""}`}
            />
          ))}
        </Flex>
      )}
    </div>
  );
};

export default Dialog;
